/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import LayersFilterPanel from "./LayersFilterPanel"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import SingleSectionLayer from "./SingleSectionLayer"
import CurrentLayerPanel from "./CurrentLayerPanel"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import updateHistory from "../utils/updateHistory"

export const Layers = () : JSX.Element => {
    
    const onLayers  = (isVisible: boolean, isInvisible: boolean): ILandingSection[] => {
        return currentLanding.sections
            .filter((s: ILandingSection) => {
                if(isVisible && isInvisible)
                    return true
                else if(isVisible)
                    return !s.isHidden
                else if(isInvisible)
                    return s.isHidden
                else
                    return true
            } )
    }

    const { currentLanding, }	= useLandingStore((state: ILandingStore) => state)  
    const [isVisible, setIsVisible] = useState<boolean>( true )
    const [isInvisible, setIsInvisible] = useState<boolean>( false ) 
    const [layers, setLayers] = useState<ILandingSection[]>( onLayers(true, false) ) 

    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection[] = currentLanding.sections 
                if( JSON.stringify(sec) !== JSON.stringify(layers) ) { 
                    setLayers(() => {
                        return sec
                    })
                }
            }, 
            {} 
        )
        return () => {
            unsubscribe();
        };
    }, []) 

    const onVisible = (_isVisible: boolean ) => {
        setIsVisible( _isVisible )
        setLayers( onLayers(_isVisible, isInvisible) )
    }
    const onInvisible = (_isInvisible: boolean ) => {
        setIsInvisible( _isInvisible )
        setLayers( onLayers(isVisible, _isInvisible) )
    }

    // a little function to help us with reordering the result
    const reorder = (list: any[], startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed); 
        return result;
    }; 

    const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({ 
        userSelect: "none",
        padding: 0, 
        margin: `0 0 0 0`, 
        width: "100%",
        // change background colour if dragging
        background: isDragging ? "#45526d" : "transparent", 
        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver: boolean) => ({
        background: isDraggingOver ? "#213146cc" : "transparent",
        padding: 0, 
        display:"flex",
        flexDirection:"column"
    })
    const onDragEnd = (result: any) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        } 
        const _items: any[]= reorder(
            layers,
            result.source.index,
            result.destination.index
        ); 
        setLayers(_items) 
        const step: IHistoryStep = {
            data : _items.map(item => item.id),
            prevData: currentLanding.sections.map((section: ILandingSection) => section.id),
            type: HISTORY_TYPE.SECTIONS_ORDER
        }
        updateHistory(step, { ...currentLanding, sections: _items })  
    }
    
    return <div className="landing-edit-layer">
        <LayersFilterPanel onVisible={onVisible} onInvisible={onInvisible} />
        <div className="panel-list overflow-y-auto">
            <DragDropContext onDragEnd={ onDragEnd }>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            { 
                                layers.map(( section: ILandingSection, index: number ) => {
                                    return <div key={section.id} className="d-flex"> 
                                        <Draggable draggableId={section.id.toString()} index={index}>
                                            {(provided, snapshot) => ( 
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                > 
                                                    <SingleSectionLayer section={section} /> 
                                                </div>
                                            )}
                                        </Draggable>
                                    </div>
                                })
                            }
                        </div>
                    )}
                </Droppable >
            </DragDropContext>        
        </div>
        <CurrentLayerPanel />
    </div>

}